import React from 'react';
import { Form } from 'antd';
import { CalendarOutlined, InfoCircleOutlined } from '@ant-design/icons';
import DdnHeField from '../components/DdnHeField';
import { t } from "@lingui/core/macro";
import { useFormPath } from './index';

export default (formPlugin, namespace) => {
    return {
        Renderer: (props) => {

            const { listFieldProps, buildName } = useFormPath()

            if (props.remove) {
                formPlugin.onAddFormPlugin(props, props.nodeId, props.pluginConfig.id)
            }

            if ((props.isPreviewMode || props.readOnly) && !props.data.fieldKey) {
                return null
            }

            const { data } = props

            let tooltip = null
            if (data.tooltip) {
                tooltip = {
                    title: data.tooltip,
                    icon: <InfoCircleOutlined />,
                }
            }

            const finalName = "[ANNIV]_" + data.fieldKey

            return (
                <Form.Item
                    {...(listFieldProps || {})}
                    label={`${data.label || t`Date de naissance`} :`}
                    name={buildName(finalName)}
                    rules={[{ required: data.required || false, message: t`Ce champ est obligatoire` }]}
                    tooltip={tooltip}
                >
                    <DdnHeField />
                </Form.Item>
            )
        },
        namespace: namespace,
        id: 'form-contact-ddn' + namespace,
        title: t`Date de naissance`,
        description: t`Élément de formulaire utilisable.`,
        icon: <CalendarOutlined />,
        iconColor: "#F39C12",
        version: 1,
        controls: {
            type: 'autoform',
            schema: {
                properties: {
                    required: {
                        type: 'boolean',
                        uniforms: {
                            label: t`Obligatoire`,
                        }
                    },
                    fieldKey: {
                        type: 'string',
                        uniforms: {
                            required: true,
                            label: t`Identifiant`,
                            placeholder: t`Identifiant du champ`,
                        }
                    },
                    label: {
                        type: 'string',
                        uniforms: {
                            label: t`Étiquette`,
                            placeholder: t`Libellé`,
                        }
                    },
                    tooltip: {
                        type: 'string',
                        uniforms: {
                            label: t`Message d'aide`,
                            placeholder: t`Message d'aide`,
                            multiline: true,
                            rows: 2,
                        }
                    }
                }
            },
        },
    }
}
